export default "__VITE_ASSET__5430b352__"